import React from "react";
import "../Complexes/ResidentialComplexList.css";
import CorpsRow from "./CorpsRow";
import EmptyState from "../EmptyState";

export default function CorpsList({
  items = [],
  loading = false,
  onItemClick,
  flashIds,
  onEdited,
  emptyActionLabel,
  onEmptyAction,
}) {
  if (loading) {
    return (
      <div className="rc-building-list">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="rc-building-row rc-building-row--skeleton" />
        ))}
      </div>
    );
  }
  if (!items.length) {
    return (
      <EmptyState
        icon="house"
        title="Корпусов пока нет"
        subtitle="Можно работать и без корпусов"
        actionLabel={emptyActionLabel || "Добавить корпус"}
        onAction={onEmptyAction}
      />
    );
  }
  return (
    <div className="rc-building-list">
      {items.map((c) => (
        <CorpsRow
          key={c.id}
          id={c.id}
          name={c.name}
          createdAt={c.created_at}
          devices={c.devices}
          buildingId={c.buildingId}
          onClick={onItemClick ? () => onItemClick(c.id) : undefined}
          isNew={!!flashIds?.has?.(c.id)}
          onEdited={onEdited}
        />
      ))}
    </div>
  );
}
